import { Building2, Hash, User } from 'lucide-react'

import { CopiableContactField } from '@/components/research-bar/copiable-contact-field'
import {
  BANK_ACCOUNT_HOLDER,
  BANK_BIC,
  BANK_IBAN,
  BANK_NAME,
  REUNION_BANK_ACCOUNT_HOLDER,
  REUNION_BANK_BIC,
  REUNION_BANK_IBAN,
  REUNION_BANK_NAME,
} from '@/lib/constants/agency'

interface BankDetailsGridProps {
  isReunion?: boolean
}

export function BankDetailsGrid({ isReunion }: BankDetailsGridProps) {
  const accountHolder = isReunion ? REUNION_BANK_ACCOUNT_HOLDER : BANK_ACCOUNT_HOLDER
  const iban = isReunion ? REUNION_BANK_IBAN : BANK_IBAN
  const bic = isReunion ? REUNION_BANK_BIC : BANK_BIC
  const bankName = isReunion ? REUNION_BANK_NAME : BANK_NAME

  return (
    <div className="mt-1 grid grid-cols-1 gap-3 md:grid-cols-2">
      <CopiableContactField icon={User} label="Nom" value={accountHolder} />
      <CopiableContactField icon={Hash} label="IBAN" value={iban} />
      <CopiableContactField icon={Building2} label="Banque" value={bankName} />
      <CopiableContactField icon={Hash} label="Code banque" value={bic} />
    </div>
  )
}
